import { v4 as uuid } from 'uuid';
import { i18n_t as $t } from '@utils/i18n';

export function getCustomerIds (customers) {
    return Object.entries(customers)
        .filter(([, data]) => !data?.filtered)
        .map(([id]) => id);
}

function buildSegmentName (productArea) {
    let name = $t('askPendo.nextActions.Customer_finder_segment');
    if (productArea) name += ` - ${productArea}`;

    return name;
}

export function buildFiltersFromCustomerIds (customerIds) {
    return [
        {
            key: uuid(),
            or: customerIds.map((customerId) => ({
                key: uuid(),
                group: 'auto',
                kind: 'visitor',
                field: 'visitor.auto.id',
                id: 'visitor_auto_id',
                type: 'visitor.auto.id',
                name: 'Visitor ID',
                schema: 'string',
                elementType: '',
                operator: '==',
                $valid: true,
                value: customerId,
            })),
        },
    ];
}

export function buildSegment (customers, productArea) {
    const customerIds = getCustomerIds(customers);
    const filters = buildFiltersFromCustomerIds(customerIds);

    return {
        definition: { filters },
        name: buildSegmentName(productArea),
        shared: true,
    };
}

export function escapeCsv (value) {
    const str = String(value ?? '');

    return /[",\n\r\t]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
}

export function downloadFile (content, filename, mimeType = 'text/plain') {
    const blob = new Blob([content], { type: mimeType });
    const url = URL.createObjectURL(blob);

    const link = Object.assign(document.createElement('a'), {
        href: url,
        download: filename,
    });

    link.click();
    URL.revokeObjectURL(url);
}
